module.exports = __webpack_public_path__ + "img/76.1d913ea4.jpg";